<router-outlet></router-outlet>
<app-dhabi-loader></app-dhabi-loader>

